import './App.scss';
import { BrowserRouter, Route, Switch} from "react-router-dom";
import { useMediaQuery} from 'react-responsive';
import { ReactChannelIO } from "react-channel-plugin";
import MainPage from './pages/pc/MainPage';
import MobileMainPage from './pages/mobile/MainPage';
import SnsPackage from './components/sns';
import PageNotFound from './components/PageNotFound';
import Posts from './pages/Posts';

const Channel = () => {
  const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  
  return (<ReactChannelIO
    pluginKey="0c676c98-92fe-4ea4-8a64-73ee4e1d8e67"
    // hideChannelButtonOnBoot={true}
    // profile={userProfile}
    locale="ko"
    autoBoot
    autoBootTimeout={2000}
    language={"ko"}
  >
    <SnsPackage mobile={mobile} />        
  </ReactChannelIO>
  )};

function Main() {
  const isMobile = useMediaQuery({
    query: "(min-width:0px) and (max-width:649px)",
  });  

  if (isMobile) return <><MobileMainPage /><Channel /></>;
  return <><MainPage /><Channel /></>;
}

function App() {

  return (
      <Switch>
        <Route path={"/"} exact component={Main} />
        <Route path={"/test"} component={Posts} />
        <Route component={PageNotFound} />
      </Switch>
  );
}

export default App;
